import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { customStepUp } from '../../actions/SignInSliderActions';
import { startSyfApplication } from '../../actions/ApplySyfAction';
import { getApplySyfPreferences, getApplySyf } from '../../selectors/applySyfSelector';
import WrappedComponent from './WrappedComponent';
import AnalyticsAction from '../../actions/AnalyticsAction';

function mapStateToProps(state, props) {
    return {
        applySyf: getApplySyf(state, props),
        preferences: getApplySyfPreferences(state, props),
    };
}
const { triggerNavigationClick } = AnalyticsAction;
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            customStepUp,
            startSyfApplication,
            triggerNavigationClick,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
